import React from 'react';
import * as apiCaller from '../../../../helpers/apiCaller'
import serviceUrls from '../../../../constants/serviceUrls';
import uiHelpers from '../../../../helpers/uiHelpers';
import { isStringNullOrEmpty } from '../../../../helpers/validators';
import { AsteriskRed } from '../../../../components/tools/Others';
import { InputText } from '../../../../components/tools/BootstrapControls';
import { convertMeterCommissionStatus } from '../../../../helpers/converters';

export default class MeterCommissionAdminResendLidVendorLink  extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            confirming:false
            , submitting:false
            , succeeded:false
            , comments:''
            , commentsError:null
        };
    }

    onExecuteClick = () => {
        if(isStringNullOrEmpty(this.state.comments)) {
            this.setState({commentsError:'This is required'})
        } else {
            this.setState({commentsError:null, confirming:true});
        }
        
    }
    onCancelClick = () => {this.setState({confirming:false});}

    onConfirmClick = async () => {
        uiHelpers.showProgressOnTop('Resending link...');
        this.setState({submitting:true})
        await apiCaller.post(serviceUrls.meterCommission.adminResendLidVendorLink,{id:this.props.meterCommission.id, comments:this.state.comments});
        await this.props.refreshPage();
        this.setState({succeeded:true, submitting:false});

    }

    renderWhatWillHappen = () => {
        return <p>
            The system will resend the link to the LID vendor to configure the LID for this meter.
        </p>
    }

    renderMainFunction = () => {

        

        return <>

            <div className='row mb-3'>
                <div className='col-md-4'>
                    Comments <AsteriskRed/>
                </div>
                <div className='col-md-8'>
                    <InputText
                        value={this.state.comments} 
                        error={this.state.commentsError} 
                        disabled={this.state.confirming || this.state.succeeded}
                        onChange={(e)=>this.setState({comments:e.target.value})} 
                    /> 
                </div>
            </div>

            {!this.state.confirming && !this.state.succeeded && <>
                
                <div className='row mb-3'>
                    <div className='col-md-4'/>
                    <div className='col-md-8'>
                        <button className='btn btn-primary' onClick={this.onExecuteClick}>Proceed</button>
                    </div>
                </div>
            </>}

            {this.state.confirming && !this.state.succeeded && <div className='card border-1 mb-3'>
                <div className='card-body bg-info bg-opacity-10 text-center'>
                    <p className='text-primary'>
                        <b>Please confirm that you would like to proceed with this action.</b>
                    </p>
                    {this.renderWhatWillHappen()}
                    <div>
                        <button type="button" class="btn btn-secondary me-3" onClick={this.onCancelClick} disabled={this.state.submitting}>
                            Cancel
                        </button>
                        <button type="button" class="btn btn-primary" onClick={this.onConfirmClick} disabled={this.state.submitting} >
                            Confirm
                        </button>
                    </div>
                </div>
            </div>}

            {this.state.succeeded && <div className='card border-success border-1 mb-3'>
                <div className='card-body bg-success bg-opacity-10 text-center text-success'>
                    <b>Email has been resent to the LID Vendor.</b>
                </div>
            </div>}

        </>
    }

    render() {
        if(this.props.meterCommission.status!='PENDING_LID_REGISTRATION') {
            return <div className='alert alert-warning'>
                This function can only be used for <b>{convertMeterCommissionStatus('PENDING_LID_REGISTRATION')}</b> forms.
            </div>
        }

        return this.renderMainFunction()
    }
}